import * as React from "react";

interface IDualColRowProps {
  title: React.ReactNode;
}

export const DualColRow: React.FC<IDualColRowProps> = ({ title, children }) => (
  <div className="row">
    <span className="left description">{title}</span>
    <span className="right description">{children}</span>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/common/DualColRow/DualColRow.tsx